import React, { forwardRef } from 'react';
import './Select.css';
import { FiChevronDown } from 'react-icons/fi';

/**
 * Select Component
 * @param {string}   label
 * @param {string}   id
 * @param {Array}    options   - [{value, label}]
 * @param {string}   error
 * @param {string}   hint
 * @param {string}   placeholder
 * @param {boolean}  required
 */
const Select = forwardRef(({
  label,
  id,
  options = [],
  error,
  hint,
  placeholder = 'Select an option',
  required = false,
  className = '',
  ...rest
}, ref) => {
  return (
    <div className={`select-group ${error ? 'select-group--error' : ''} ${className}`}>
      {label && (
        <label htmlFor={id} className="select-label">
          {label}
          {required && <span className="select-required" aria-hidden="true"> *</span>}
        </label>
      )}
      <div className="select-wrapper">
        <select
          ref={ref}
          id={id}
          className="select-field"
          aria-invalid={!!error}
          {...rest}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className="select-chevron" aria-hidden="true">
          <FiChevronDown />
        </span>
      </div>
      {error && <p className="select-error-msg" role="alert">{error}</p>}
      {!error && hint && <p className="select-hint">{hint}</p>}
    </div>
  );
});

Select.displayName = 'Select';
export default Select;
